"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StepSlide = exports.StepMedia = exports.StepContent = exports.StepCard = exports.Right = exports.Left = exports.FadeOutIconsWrapper = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _vars = require("../../../styles/vars");
var _StepContent = require("../../StepContent");
var _StepMedia = _interopRequireDefault(require("./StepMedia"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
//helpers

//components

var StepSlide = exports.StepSlide = _styledComponents["default"].div.withConfig({
  displayName: "styles__StepSlide",
  componentId: "sc-1dcr1q8-0"
})(["height:100%;position:relative;display:flex;flex-direction:column;.stepNumber{left:0;top:", ";transform:translateX(-50%);}"], function (p) {
  return p.hasReportButton ? '4rem' : '2rem';
});
var StepCard = exports.StepCard = _styledComponents["default"].div.withConfig({
  displayName: "styles__StepCard",
  componentId: "sc-1dcr1q8-1"
})(["", ";background:#fff;border-radius:", "px;display:flex;flex-direction:", ";height:100%;"], (0, _vars.cardShadowCss)(false), _vars.borderRadius.mobile, function (p) {
  return p.orientation === 'portrait' ? 'column-reverse' : 'row';
});
var Left = exports.Left = _styledComponents["default"].div.withConfig({
  displayName: "styles__Left",
  componentId: "sc-1dcr1q8-2"
})(["display:flex;flex-basis:0;flex-direction:column;flex-grow:1;flex-shrink:1;min-height:0;position:relative;"]);
var Right = exports.Right = _styledComponents["default"].div.withConfig({
  displayName: "styles__Right",
  componentId: "sc-1dcr1q8-3"
})(["position:relative;", " ", ""], function (p) {
  return p.orientation === 'landscape' && "\n    height: 100%;\n    width: 50%;\n  ";
}, function (p) {
  return p.orientation === 'portrait' && "\n    width: 100%;\n\n    &::before {\n      content: '';\n      display: block;\n      padding-top: 75%;\n    }\n  ";
});
var StepContent = exports.StepContent = (0, _styledComponents["default"])(_StepContent.StepContentMobile).withConfig({
  displayName: "styles__StepContent",
  componentId: "sc-1dcr1q8-4"
})(["flex:1;"]);
var StepMedia = exports.StepMedia = (0, _styledComponents["default"])(_StepMedia["default"]).withConfig({
  displayName: "styles__StepMedia",
  componentId: "sc-1dcr1q8-5"
})(["height:100%;left:0;position:absolute;top:0;width:100%;"]);
var FadeOutIconsWrapper = exports.FadeOutIconsWrapper = _styledComponents["default"].div.withConfig({
  displayName: "styles__FadeOutIconsWrapper",
  componentId: "sc-1dcr1q8-6"
})(["margin:0 0 10px 15px;"]);
//# sourceMappingURL=styles.js.map